<template>
  <div class="status-card status-rejected">
    <div class="status-header">
      <div class="status-icon-wrapper rejected">
        <img
          alt="rejected"
          width="48px"
          :src="iconError"
        >
      </div>
      <h3 class="status-title">
        Hợp đồng bị từ chối
      </h3>
    </div>

    <div class="status-content">
      <template v-if="errorMessage">
        <p class="status-description status-error-message text-center">
          {{ errorMessage }}
        </p>
        <p class="status-guidance text-center">
          Nếu thông tin không hợp lệ, vui lòng cập nhật lại thông tin bên dưới và gửi lại để được xét duyệt.
        </p>
      </template>
      <p
        v-else
        class="status-description"
      >
        Hợp đồng của bạn đã bị từ chối. Vui lòng liên hệ support để được hỗ trợ.
      </p>

      <div class="action-buttons">
        <btn-loading
          variant-convert="btn-submit"
          @click.prevent="goToUpdateInformation"
        >
          <div class="d-flex align-items-center">
            <feather-icon
              icon="Edit2Icon"
              size="16"
              class="mr-1"
            />
            <span>Cập nhật thông tin</span>
          </div>
        </btn-loading>
      </div>

      <user-hint class="justify-content-center mt-4" />
    </div>
  </div>
</template>

<script>
import UserHint from '@/components/UserHint.vue'
import BtnLoading from '@/layouts/components/BtnLoading.vue'
import iconError from '@/assets/images/icons/icon-error.svg'

export default {
  name: 'RejectedStatus',

  components: {
    UserHint,
    BtnLoading,
  },

  props: {
    errorMessage: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      iconError,
    }
  },
  methods: {
    goToUpdateInformation() {
      this.$router.push({ path: '/update-information', query: { step: 2 } })
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables/_variables.scss";

.status-card {
  background: #ffffff;
  border-radius: 16px;
  padding: 32px;

  @media(max-width: 767px) {
    padding: 24px;
    border-radius: 12px;
  }
}

.status-header {
  text-align: center;
  margin-bottom: 28px;
}

.status-icon-wrapper {
  width: 80px;
  height: 80px;
  margin: 0 auto 16px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  img {
    display: block;
    margin: 0 auto;
  }

  &.rejected {
    background: linear-gradient(135deg, rgba(239, 68, 68, 0.1) 0%, rgba(220, 38, 38, 0.1) 100%);
  }
}

.status-title {
  font-size: 24px;
  font-weight: 600;
  color: #1f2937;
  margin: 0;
  line-height: 1.4;

  @media(max-width: 767px) {
    font-size: 20px;
  }
}

.status-content {
  text-align: left;
}

.status-description {
  font-size: 16px;
  line-height: 1.6;
  color: #4b5563;
  margin-bottom: 24px;
  text-align: center;

  @media(max-width: 767px) {
    font-size: 14px;
    margin-bottom: 20px;
  }

  &.status-error-message {
    color: #dc2626;
    background: #fef2f2;
    border-radius: 8px;
    padding: 16px;
    text-align: left;
  }

  &.status-guidance {
    font-size: 14px;
    line-height: 1.5;
    color: #6b7280;
    margin-top: -8px;
    margin-bottom: 24px;

    @media(max-width: 767px) {
      font-size: 13px;
      margin-top: -4px;
      margin-bottom: 20px;
    }
  }
}

.action-buttons {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 24px;
  align-items: stretch;

  @media(min-width: 768px) {
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: 16px;
  }

  :deep(.btn-loading) {
    min-width: 200px;
    width: 100%;

    @media(min-width: 768px) {
      width: auto;
      min-width: 180px;
    }
  }
}
</style>
